import $ from "jquery";

/** ASYNC AUTO-EXECUTABLE SCRIPT */
(async () => {
  /** check for library loaded */
  if (window.RAC.loaded) {
    // console.log("HAFF - Hide Aventri Form Fields - Script Loaded.");
    console.log("HAFF - Script Loaded.");

    /** time */
    console.time("HAFF - Fields Hidden Time");

    /** destruct */
    let { aventriFields } = window.RAC.config;

    /** init */
    let fieldsToHide: string[] = [];
    let inputPrefix: string = "input[id*=";
    let hiddenParentFieldStyle: string = "position: absolute; pointer-events: none; opacity: 0; z-index: -99999";

    /** push fields to hide */
    fieldsToHide.push(`textarea[id*=${aventriFields.atlasRecommendationsBlock}]`);
    fieldsToHide.push(`textarea[id*=${aventriFields.logs}]`);
    fieldsToHide.push(`${inputPrefix}${aventriFields.atlasRegistrationId}]`);
    fieldsToHide.push(`${inputPrefix}${aventriFields.integrationStatus}]`); // not implemented
    /** hide recom fields */
    aventriFields.recommendationsFields.forEach((recomField) => {
      fieldsToHide.push(`${inputPrefix}${recomField.a}]`);
      fieldsToHide.push(`${inputPrefix}${recomField.b}]`);
      fieldsToHide.push(`${inputPrefix}${recomField.c}]`);
      fieldsToHide.push(`${inputPrefix}${recomField.d}]`);
      fieldsToHide.push(`${inputPrefix}${recomField.e}]`);
      fieldsToHide.push(`${inputPrefix}${recomField.f}]`);
    });

    /** hide fields  */
    fieldsToHide.forEach((field) => {
      let elementToHide = $(field).parent().parent().parent().parent();
      if (elementToHide.length > 0) elementToHide[0].style.cssText = hiddenParentFieldStyle;
    });

    /** time */
    console.timeEnd("HAFF - Fields Hidden Time");
  } else {
    console.error("Library is not loaded.");
  }
})();
